<form class="object-custom-fields-form" [formGroup]="form" (ngSubmit)="onSave()" *ngIf="definitions.length">
  <div class="standard-input has-icon" *ngFor="let customField of definitions">
    <label>
      {{ getLabel(customField) }}
      <span class="required-star" *ngIf="customField.is_required">*</span>
    </label>
        <ng-container [ngSwitch]="customField.field_type">
        <ui-form-field
          *ngSwitchCase="customFieldTypes.SINGLE_SELECT"
          type="select"
          [options]="getSingleSelectOptions(customField)"
          [fullWidth]="true"
          [hideErrors]="true"
          [formControlName]="customField.technical_name"
        ></ui-form-field>

        <ui-form-field
          *ngSwitchCase="customFieldTypes.MULTI_SELECT"
          type="select"
          [multiple]="true"
          [emptySelectText]="''"
          [options]="getMultiSelectOptions(customField)"
          [fullWidth]="true"
          [hideErrors]="true"
          [formControlName]="customField.technical_name"
        ></ui-form-field>

        <ui-form-field
          *ngSwitchCase="customFieldTypes.RICH_TEXT"
          type="textarea"
          [fullWidth]="true"
          [hideErrors]="true"
          [formControlName]="customField.technical_name"
        ></ui-form-field>

        <mat-checkbox
            *ngSwitchCase="customFieldTypes.BOOLEAN"
            class="standard-input-value checkbox-input"
            [formControlName]="customField.technical_name"
            [required]="customField.is_required"
        ></mat-checkbox>

        <ng-container *ngSwitchCase="customFieldTypes.DATE">
            <div class="input-container">
                <input
                    type="text"
                    matInput
                    [matDatepicker]="picker"
                    class="standard-input-value"
                    [formControlName]="customField.technical_name"
                    [placeholder]="'common.select_date' | translate"
                    [required]="customField.is_required"
                    readonly="true"
                    (click)="picker.open()"
                />
                <button
                    type="button"
                    class="btn-icon"
                    (click)="picker.open()"
                    tabindex="-1"
                    aria-label="Open calendar"
                >
                    <ui-svg-icon svgIcon="calendar-cc"></ui-svg-icon>
                </button>
                <mat-datepicker #picker></mat-datepicker>
            </div>
        </ng-container>
        <ui-form-field
          *ngSwitchDefault
          [type]="getUiFormFieldType(customField.field_type)"
          [fullWidth]="true"
          [hideErrors]="true"
          [formControlName]="customField.technical_name"
        ></ui-form-field>
        </ng-container>

        <div class="field-error" *ngIf="isControlInvalid(customField.technical_name)">
        {{ 'common.required_field' | translate }}
        </div>
  </div>

  <div class="custom-fields-actions" *ngIf="showSaveButton">
    <ui-button type="primary" [label]="'common.save' | translate" (click)="onSave()">
    </ui-button>
  </div>
</form>

